import React from 'react';
import Header from '@shared/header/header.container';
import { HeaderType } from '../../types/app.types';
import { FormType } from '../../types/form.types';
import ContactForm from '../contact-form/contact-form.container';
import GoBack from '../shared/go-back/go-back.container';

interface ContactFormPageContentProps {
  headerType: HeaderType;
  type: FormType;
}

const ContactFormPageContent: React.FunctionComponent<ContactFormPageContentProps> = ({
  headerType,
  type
}) => {
  return (
    <>
      <Header type={headerType} isFormPage />
      <GoBack />
      <ContactForm type={type} />
    </>
  );
};

export default ContactFormPageContent;
